import {OrganisationDropdown} from './organisation_dropdown'
import {BillingInfoDropdown} from './billing_info_dropdown'
import {EnvironmentDropdown} from './environment_dropdown'

export const SearchFirmRowDropdown = ({row}) => {
	const {tableName, id} = row.original

	switch (tableName) {
		case 'organisations':
			return <OrganisationDropdown id={id} />
		case 'billingInfos':
			return <BillingInfoDropdown id={id} />
		case 'environments':
			return <EnvironmentDropdown id={id} />
	}
}
